function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { UPLOADCARE_CDN_URL } from "../constants.mjs";
export class UploadcareGifVideo {
  constructor(props) {
    var _props$effects;
    _defineProperty(this, "uuid", void 0);
    _defineProperty(this, "filename", void 0);
    _defineProperty(this, "mimeType", void 0);
    _defineProperty(this, "size", void 0);
    _defineProperty(this, "width", void 0);
    _defineProperty(this, "height", void 0);
    _defineProperty(this, "effects", void 0);
    if (props.mimeType !== 'image/gif') {
      throw new Error("Only GIF images are allowed. Given: \"".concat(props.mimeType, "\"."));
    }
    this.uuid = props.uuid;
    this.filename = props.filename;
    this.mimeType = props.mimeType;
    this.size = props.size;
    this.width = props.width;
    this.height = props.height;
    this.effects = (_props$effects = props.effects) !== null && _props$effects !== void 0 ? _props$effects : [];
  }
  format(format) {
    /** @see https://uploadcare.com/docs/image_transformations/gif2video/#gif2video-format */
    return this.withEffect("/format/".concat(format, "/"));
  }
  quality(quality) {
    /** @see https://uploadcare.com/docs/image_transformations/gif2video/#gif2video-quality */
    return this.withEffect("/quality/".concat(quality, "/"));
  }
  bestQuality() {
    return this.quality('best');
  }
  get aspectRatio() {
    return this.width / this.height;
  }
  withEffect(effect) {
    return new UploadcareGifVideo({
      uuid: this.uuid,
      filename: this.filename,
      mimeType: this.mimeType,
      size: this.size,
      width: this.width,
      height: this.height,
      effects: [...this.effects, effect]
    });
  }
  get cdnUrl() {
    var cdnUrl = [UPLOADCARE_CDN_URL, this.uuid, 'gif2video',
    // Prepend a dash only if effects exist.
    // It doesn't matter if there's a dash at the end of URL even if there are no effects,
    // but it looks cleaner without it.
    this.effects.length === 0 ? this.effects : ['', ...this.effects].join('-')].join('/');
    return "".concat(cdnUrl).concat(encodeURIComponent(this.filename));
  }
  get downloadUrl() {
    var downloadUrl = [UPLOADCARE_CDN_URL, this.uuid, 'gif2video', ['', ...this.effects, '/inline/no/'].join('-')].join('/');
    return "".concat(downloadUrl).concat(encodeURIComponent(this.filename));
  }
}